import React from "react";
import { timestampToDateString } from "../../../../utils/dates";
import { feeHighlightClass, formatFeeOrNoFee } from "../formatters";
import {
  selectEventData,
  selectFeeHighlights,
  selectSelectedSpecialEventFees,
} from "../editParticipant.selectors";
import { useSelector } from "react-redux";

export default function ProgramRegistrationFeesSection (): React.ReactElement {
  const eventData = useSelector(selectEventData);
  const feeHighlights = useSelector(selectFeeHighlights);
  const selectedSpecialEventFees = useSelector(selectSelectedSpecialEventFees);
  const registrantFee = eventData?.fee?.memberFee ?? eventData?.fee?.fee;

  return (
    <div>
      <h3 className="w-full text-secondary mb-4">
        Program Registration Fees
      </h3>
      <div className="grid grid-cols-1 md:flex flex-wrap gap-8 md:gap-10">
        <div className={`flex flex-col gap-1 ${feeHighlightClass(feeHighlights.memberFee)}`}>
          <label className="font-semibold">Registrant Fee</label>
          {formatFeeOrNoFee(registrantFee)}
        </div>
        <div className={`flex flex-col gap-1 ${feeHighlightClass(feeHighlights.lateMemberFee)}`}>
          <label className="font-semibold">Late Registrant Fee</label>
          {formatFeeOrNoFee(eventData?.fee?.lateFee)}
        </div>
        <div className={`flex flex-col gap-1 ${feeHighlightClass(feeHighlights.guestFee)}`}>
          <label className="font-semibold">Guest Fee</label>
          {formatFeeOrNoFee(eventData?.fee?.guestFee)}
        </div>
        <div className={`flex flex-col gap-1 ${feeHighlightClass(feeHighlights.guestLateFee)}`}>
          <label className="font-semibold">Guest Late Fee</label>
          {formatFeeOrNoFee(eventData?.fee?.guestLateFee)}
        </div>
        <div className={`flex flex-col gap-1 ${feeHighlightClass(feeHighlights.specialEventFee)}`}>
          <label className="font-semibold">Special Event Fee</label>
          {formatFeeOrNoFee(selectedSpecialEventFees?.eventFee)}
        </div>
        <div className={`flex flex-col gap-1 ${feeHighlightClass(feeHighlights.specialEventGuestFee)}`}>
          <label className="font-semibold">Special Event Guest Fee</label>
          {formatFeeOrNoFee(selectedSpecialEventFees?.guestFee)}
        </div>
        <div className={`flex flex-col gap-1 ${feeHighlightClass(feeHighlights.lateFeeDate)}`}>
          <label className="font-semibold">Registration Late Fee Date</label>
          {eventData?.fee?.lateFeeDate ?? eventData?.fee?.noRefundDate
            ? timestampToDateString(
              (eventData.fee.lateFeeDate ?? eventData.fee.noRefundDate) as number,
            )
            : "-"}
        </div>
      </div>
    </div>
  );
}
